export const ValidAppViewRoutes = ['u2f', 'extension'];
